import { useEffect, useState } from "react";
import { SESSION_LOGIN_TIME_KEY } from "@features/auth/queries";

const SESSION_DURATION_MS = 8 * 60 * 60 * 1000;
const WARN_THRESHOLD_MS = 30 * 60 * 1000;

export function useSessionExpiry(enabled: boolean) {
  const [minutesLeft, setMinutesLeft] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled) { setMinutesLeft(null); return; }
    const check = () => {
      const raw = localStorage.getItem(SESSION_LOGIN_TIME_KEY);
      if (!raw) {
        localStorage.setItem(SESSION_LOGIN_TIME_KEY, String(Date.now()));
        setMinutesLeft(Math.round(SESSION_DURATION_MS / 60_000));
        return;
      }
      const loginMs = Number(raw);
      const elapsed = Date.now() - loginMs;
      const remaining = SESSION_DURATION_MS - elapsed;
      if (remaining <= 0) setMinutesLeft(0);
      else if (remaining <= WARN_THRESHOLD_MS) setMinutesLeft(Math.ceil(remaining / 60_000));
      else setMinutesLeft(null);
    };
    check();
    const id = setInterval(check, 60_000);
    return () => clearInterval(id);
  }, [enabled]);

  return minutesLeft;
}
